import {BenchlingExpressionFunction} from 'benchling-expressions/BenchlingExpressionTypes';
import {BenchlingExpressionFunctionName} from 'benchling-expressions/BenchlingFunctionSignatures';
import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ProcessFlowchartForValidation} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

export default function doesFlowchartHaveRouterWithAndOrFunction(
  flowchart: ProcessFlowchartForValidation
): boolean {
  for (const node of flowchart.nodes) {
    if (node.type === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS) {
      for (const spec of node.routerConfig.functionSpecs) {
        if (
          spec.expression != null &&
          [BenchlingExpressionFunctionName.AND, BenchlingExpressionFunctionName.OR].includes(
            (spec.expression as BenchlingExpressionFunction).name as BenchlingExpressionFunctionName
          )
        ) {
          return true;
        }
      }
    }
  }
  return false;
}
